var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00156 1.59961C4.46876 1.59961 1.60156 4.46681 1.60156 7.99961C1.60156 11.5324 4.46876 14.3996 8.00156 14.3996C11.5344 14.3996 14.4016 11.5324 14.4016 7.99961C14.4016 4.46681 11.5344 1.59961 8.00156 1.59961ZM8.00156 13.1196C5.17276 13.1196 2.88156 10.8284 2.88156 7.99961C2.88156 5.17081 5.17276 2.87961 8.00156 2.87961C10.8304 2.87961 13.1216 5.17081 13.1216 7.99961C13.1216 10.8284 10.8304 13.1196 8.00156 13.1196Z",
    fill: "#BE1E2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22491 8.91927L5.8816 7.57597C5.75808 7.46274 5.61397 7.40612 5.44927 7.40612C5.28458 7.40612 5.13532 7.46788 5.00151 7.59141C4.86769 7.72522 4.80078 7.87448 4.80078 8.03918C4.80078 8.20387 4.86769 8.34283 5.00151 8.45606L6.79258 10.2626C6.9161 10.3861 7.06021 10.4479 7.22491 10.4479C7.3896 10.4479 7.53371 10.3861 7.65723 10.2626L11.2548 6.63411C11.3783 6.52088 11.4375 6.38192 11.4324 6.21722C11.4272 6.05252 11.3629 5.90841 11.2394 5.78489C11.1262 5.66137 10.982 5.59961 10.8071 5.59961C10.6321 5.59961 10.4828 5.66137 10.3593 5.78489L7.22491 8.91927Z",
    fill: "#BE1E2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleTickIcon);
export default __webpack_public_path__ + "static/media/Circle-tick-icon.031d4bc735cb798b4d549bc2267991ab.svg";
export { ForwardRef as ReactComponent };